var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tooltip",style:(_vm.style)},[_c('div',{ref:"content",staticClass:"content"},[_c('ButtonPlain',{on:{"click":function($event){return _vm.$emit('close')}}},[_c('Close')],1),_vm._t("default"),(_vm.anchorRect)?_c('div',{staticClass:"arrow",class:_vm.showBelow ? 'above' : 'below',style:(_vm.arrowStyle)}):_vm._e()],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }